import gql from 'graphql-tag';

export const mutationDeleteIntegrationItem = gql`
  mutation deleteIntegrationItem (
    $integrationID: DokkioID!
    $remoteID: ID!
  ) {
    deleteIntegrationItem (
      integrationID: $integrationID
      remoteID: $remoteID
    )
  }
`;
export default mutationDeleteIntegrationItem;
